import { useProductAudit } from '@/hooks/useProducts'
import type { CreatedProduct } from '@/types/products'
import { AuditTrailTable } from '@/components/audit/AuditTrailTable'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog'

/**
 * The audit trail for ONE product, reached from Manage Products.
 *
 * The form-level panel answers "what happened on this form"; this answers
 * "what happened to this bag", which is the question a DIN in hand asks.
 * Both render through `AuditTrailTable`, so a column added for one cannot go
 * missing on the other.
 */
export function ProductAuditTrailDialog({
  product,
  onClose,
}: {
  product: CreatedProduct | null
  onClose: () => void
}) {
  const audit = useProductAudit(product?.id ?? null)

  return (
    <Dialog open={!!product} onOpenChange={o => !o && onClose()}>
      {/* Wider than the usual dialog cap: this is a data table with eleven
          columns, and 80rem left Description and Related behind a horizontal
          scroll on a 1440px screen. */}
      <DialogContent className='sm:max-w-[95vw]'>
        <DialogHeader>
          <DialogTitle>Audit trail</DialogTitle>
          <DialogDescription>
            {product ? `DIN ${product.din}` : ''} — every recorded transaction for this product,
            newest first.
          </DialogDescription>
        </DialogHeader>

        <AuditTrailTable
          rows={audit.data ?? []}
          isLoading={audit.isLoading}
          emptyMessage='Nothing recorded for this product yet.'
        />
      </DialogContent>
    </Dialog>
  )
}
